<template>
  <div>
    <h3 class="mt-5">Login</h3>

    <b-alert variant="success" dismissible :show="alerta.visivel" @dismissed="alerta.visivel=false">
      <div>Senha alterada com sucesso!</div>
    </b-alert>

    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fas fa-at"></i>
        <div>
          <label for="emailLogin">e-mail</label>
          <input type="text" readonly class="form-control-plaintext" id="emailLogin" v-model="aluno.email">
        </div>
      </div>
      <a href="javascript:void(0)" class="btn btn-perfil" @click="$bvModal.show('modalEmail')"
         v-if="permiteAlterarEmail">{{ $t('btn.editar') }}</a>
    </div>
    <hr>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fas fa-unlock-alt"></i>
        <div>
          <label for="senha">senha</label>
          <input type="password" readonly class="form-control-plaintext" id="senha" v-model="aluno.senha">
        </div>
      </div>
      <a href="javascript:void(0)" class="btn btn-perfil" @click="$bvModal.show('modalSenha')">{{ $t('btn.editar')
        }}</a>
    </div>
    <hr v-if="false">
    <div class="d-flex align-items-center justify-content-between" v-if="false">
      <div class="d-flex align-items-center">
        <i class="fab fa-facebook-f"></i>
        <div>
          <label for="redeSocial">Rede Social</label>
          <input type="text" readonly class="form-control-plaintext" id="redeSocial" value="Facebook">
        </div>
      </div>
      <a href="javascript:void(0)" class="btn btn-perfil" @click="$bvModal.show('modalSocial')">{{ $t('btn.editar')
        }}</a>
    </div>

    <!-- modais -->
    <b-modal hide-footer id="modalEmail" body-class="modal-conteudo pb-4" header-class="" v-if="permiteAlterarEmail">
      <template slot="modal-title">
        <h5 class="modal-title">Altere o seu e-mail</h5>
      </template>
      <form>
        <div class="form-group">
          <label for="novoEmail">Novo email</label>
          <input type="email" class="form-control" id="novoEmail" placeholder="" v-model="alunoAlteracao.email">
        </div>
        <div class="form-group">
          <label for="confNovoEmail">Confirmar novo email</label>
          <input type="email" class="form-control" id="confNovoEmail" placeholder="" v-model="alunoAlteracao.novoEmail">
        </div>
        <div class="text-center">
          <button type="button" class="btn btn-secondary my-3">Alterar e-mail</button>
        </div>
      </form>
    </b-modal>

    <b-modal hide-footer id="modalSenha" body-class="modal-conteudo pb-4" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title">Altere a sua senha</h5>
      </template>
      <b-alert variant="danger" dismissible :show="alertaModal.visivel" @dismissed="alertaModal.visivel=false">
        <div>{{ alertaModal.mensagem }}</div>
      </b-alert>
      <form>
        <form-group id="senhaAntiga" label="Senha Antiga" text="Obrigatório informar a senha antiga" :field="$v.alunoAlteracao.senha">
          <input type="password" class="form-control" id="senhaAntiga" placeholder="" v-model="alunoAlteracao.senha">
        </form-group>

        <form-group id="senhaNova" label="Insira a sua nova senha" text="Obrigatório informar a nova senha" :field="$v.alunoAlteracao.novaSenha">
          <input type="password" class="form-control" id="senhaNova" placeholder="" v-model="alunoAlteracao.novaSenha">
        </form-group>

        <form-group id="confSenhaNova" label="Confirme a sua nova senha" text="Obrigatório confirmar a nova senha" :field="$v.alunoAlteracao.confirmacaoSenha">
          <input type="password" class="form-control" id="confSenhaNova" placeholder="" v-model="alunoAlteracao.confirmacaoSenha">

          <form-validation-invalid-feedback text="A nova senha e a confirmação não são iguais" :field="$v.alunoAlteracao" v-if="!$v.alunoAlteracao.verificarConfirmacaoSenha" />
        </form-group>

        <div class="text-center">
          <button type="button" @click="alterarSenha" class="btn btn-secondary my-3">Alterar senha</button>
        </div>
      </form>
    </b-modal>

    <b-modal hide-footer id="modalSocial" body-class="modal-conteudo pb-4" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title">Redes sociais</h5>
      </template>
      <div class="row">
        <div class="col-12 col-md-6 text-center pt-3">
          <p>Você está logado no <strong>Facebook</strong></p>
          <a href="#" class="btn btn-secondary mt-3">Deslogar</a>
        </div>
        <div class="col-12 col-md-6">
          <div class="btns-social">
            <a href="#" class="btn btn-linkedin"><i class="fab fa-linkedin-in"></i> Fazer login pelo Linkedin</a>
            <a href="#" class="btn btn-google"><i class="fab fa-google-plus-g"></i> Fazer login pelo Google</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import FormValidationInvalidFeedback from '@/core/components/FormValidationInvalidFeedback'
import PerfilAPI from '@/api/perfil-api'

const verificarConfirmacaoSenha = (alunoAlteracao) => {
  return alunoAlteracao.novaSenha === alunoAlteracao.confirmacaoSenha
}

export default {
  name: 'DadosAcesso',
  components: { FormValidationInvalidFeedback, FormGroup },
  props: {
    aluno: Object
  },
  data () {
    return {
      permiteAlterarEmail: false,
      alerta: { visivel: false },
      alertaModal: { visivel: false, mensagem: '' },
      alunoAlteracao: {
        email: '',
        senha: '',
        novoEmail: '',
        novaSenha: '',
        confirmacaoSenha: ''
      }
    }
  },

  validations: {
    alunoAlteracao: {
      senha: { required },
      novaSenha: { required },
      confirmacaoSenha: { required },
      verificarConfirmacaoSenha
    }
  },

  methods: {
    alterarSenha: function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const loader = this.$loading.show()
        const self = this
        PerfilAPI.alterarSenha(this.alunoAlteracao.senha, this.alunoAlteracao.novaSenha, this.alunoAlteracao.confirmacaoSenha).then(data => {
          if (data.success === false) {
            this.alertaModal = { visivel: true, mensagem: data.status }
          } else {
            this.$bvModal.hide('modalSenha')
            this.alerta.visivel = true
            this.alunoAlteracao = {}
            this.alertaModal = { visivel: true, mensagem: data.status }
          }
          loader.hide()
        }).catch(function (error) {
          self.alertaModal = { visivel: true, mensagem: error.response.data.status }
          loader.hide()
        })
      }
    }
  }
}
</script>

<style scoped >
</style>
